import {
  SleepHabitBuilder,
  SleepSTreak,
  SleepGoalAchiver,
  LowWakeup,
  RestedNight,
  ConsistantSleeper,
  ActiveConsistancyStreak,
} from "@utils/defaultImages";

export const sleepSliderData = [
    // {
    //   RankImage: RestedNight,
    //   title: "Well-Rested Night",
    //   unlockDate: "Unlocked on 5th July",
    //   description: "Earned for getting 7+ sleep in a single night.",
    // },
    {
      RankImage: ConsistantSleeper,
      title: "Consistent Sleeper",
      unlockDate: "Unlocked on 5th July",
      description: "Awarded for maintaining 7+ hours for 3 nights in a row.",
    },
    {
      RankImage: ActiveConsistancyStreak,
      title: "Advice Consistency Streak",
      unlockDate: "Unlocked on 5th July",
      description:
        "You followed your daily advice for 5 consecutive days. Consistency is what builds real results.",
    },
    {
      RankImage: SleepSTreak,
      title: "Sleep Streak",
      unlockDate: "Unlocked on 5th July",
      description:
        "Unlocked when you Sleep 7+ hours for 5 nights in a row.",
    },
    {
      RankImage: SleepGoalAchiver,
      title: "Weekly Sleep Goal Achiever",
      unlockDate: "Unlocked on 5th July",
      description: "Awarded when you Complete 5 or more nights of 7+ hours sleep in one week.",
    },
    {
      RankImage: LowWakeup,
      title: "Low Wake-Up Master",
      unlockDate: "Unlocked on 5th July",
      description:
        "Achieved when you Record 2 or fewer wake-ups per night for 3 nights.",
    },
    {
      RankImage: SleepHabitBuilder,
      title: "Sleep Habit Builder",
      unlockDate: "Unlocked on 5th July",
      description: "Awarded when you Log sleep data for 14 total nights.",
    },
  ];